import ContributorSuggestionPage from "@/features/change-requests/contributor-suggestion.page";
import { createFileRoute } from "@tanstack/react-router";

// CR-235 D8: one suggestion's page for its submitter (guarded by the layout).
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId",
)({
  component: ContributorSuggestionPage,
});
